export const MOMENT_CALENDAR_OPTIONS = {
  sameDay: '[Today] @ hh:mm A',
  nextDay: '[Tomorrow] @  hh:mm A',
  nextWeek: 'dddd @ hh:mm A',
  lastDay: '[Yesterday] @ hh:mm A',
  lastWeek: '[Last] dddd @  hh:mm A',
  sameElse: 'DD/MM/YYYY @ hh:mm A',
} as const;
